import React, { Fragment } from 'react';

import ShowAllCollapsible from '~/components/core/Molecules/Collapsible/ShowAllCollapsible';
import Text from '~/components/core/TextComponents/Text';
import DocumentsButtonLink from '~/components/Documents/DocumentsButtonLink';
import type { NoteContentProps, NotePartProps } from '~/components/Notes/types';
import useOrganization from '~/components/OrganizationContext';

const DocumentsNote: React.FC<NoteContentProps> = ({ note, isExpanded, onCollapseClick, isCollapsible, maxRows }) => {
  return isCollapsible ? (
    <ShowAllCollapsible
      visibleLines={maxRows || 1}
      showAsInlineButton
      isOpen={isExpanded}
      onCollapseClick={onCollapseClick}
    >
      <DocumentsNoteInner note={note} />
    </ShowAllCollapsible>
  ) : (
    <DocumentsNoteInner note={note} />
  );
};

interface DocumentType {
  desc: string;
  is_public_option: boolean;
}

const DocumentsNoteInner: React.FC<NotePartProps> = ({ note }) => {
  const { documentTypesDict } = useOrganization() as { documentTypesDict: { [document_type: string]: DocumentType } };
  if (!note.documents) {
    return <></>;
  }
  return (
    <>
      <div className="my-12">
        <DocumentsButtonLink documents={note.documents} />
      </div>
      {note.documents.map((document) => (
        <Fragment key={document.id}>
          {document.is_removed && (
            <Text colorVariant={Text.COLOR_VARIANTS.ERROR} weight={Text.WEIGHTS.REGULAR} variant={Text.VARIANTS.SM}>
              Document was removed from claim, Reason: {document.removed_reason}
            </Text>
          )}
          <a
            href={`/api/v1/claims/${document.claim_id}/documents/${document.id}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Document #{document.claim_internal_id}
          </a>
          <Text weight={Text.WEIGHTS.REGULAR} variant={Text.VARIANTS.SM}>
            Name: {document.document_name}
          </Text>
          <Text weight={Text.WEIGHTS.REGULAR} variant={Text.VARIANTS.SM}>
            Type: {documentTypesDict?.[document.type]?.desc || document.type}
          </Text>
          <Text weight={Text.WEIGHTS.REGULAR} variant={Text.VARIANTS.SM}>
            Summary: {document.summary}
          </Text>
          <br />
        </Fragment>
      ))}
    </>
  );
};

export default DocumentsNote;
